module.exports = __webpack_public_path__ + "img/2.271af565.png";